// extracted by mini-css-extract-plugin
export var cartIcon = "_ls-0";
export var cartIconContainer = "_ls-1";